// extracted by mini-css-extract-plugin
export default {"skeleton-row":"SkeletonRow_skeleton-row__fF6I4","skeleton-btn":"SkeletonRow_skeleton-btn__xnjIS"};